import { useTranslation } from 'react-i18next';
import { getWorkingHoursHistoryUrl } from '@/constant/approval';
import type { ContentExtraProps } from '../../types';
import InfoTable from '@/components/Approval/@components/InfoTable';
import useAttendanceDetail from './useAttendanceDetail';
import { formatDateOnly, formatWorkingHoursRange } from './format';
import { AttendanceSlotRoot } from './styles';
import type { WorkingHoursHistory } from './types';

/** 222 (신규)근무시간 변경 */
const WorkingHoursChangeSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const { cell } = useAttendanceDetail<WorkingHoursHistory>(
    getWorkingHoursHistoryUrl(data.documentId),
  );

  return (
    <AttendanceSlotRoot>
      <InfoTable
        rows={[
          {
            label: t('현재 근무 시간'),
            value: cell((d) => formatWorkingHoursRange(d.currentWorkingHours)),
          },
          {
            label: t('변경 근무 시간'),
            value: cell((d) => formatWorkingHoursRange(d.workingHours)),
          },
          {
            label: t('변경 시작일'),
            value: cell((d) => formatDateOnly(d.changedAt)),
          },
        ]}
      />
    </AttendanceSlotRoot>
  );
};

export default WorkingHoursChangeSlot;
